/* Santas Vault - the builder on the shelf.
   ------------------------------------------------------------------
   ONE PRODUCT, MANY DESIGNS. A Santa Sack shelf is not a catalogue of 653
   things, it is one thing with 653 pictures available on it. This turns the
   shelf into the product: artwork, size, lettering, name, preview, add to
   cart, without a page load between any of them.

   HOW IT ADDS TO CART WITHOUT A PRODUCT PAGE. Each design is a real Shopify
   product with a real handle, so picking one fetches /products/<handle>.js -
   the variants, the options, the images and the price, straight from the
   storefront, no app and no API key. Add to cart then posts that product's
   variant id to /cart/add.js with the name as a line item property, which is
   exactly what the product page posts. Nothing here invents a price or a
   variant; it reads them.

   WHY THE FETCH IS CHEAP. It happens on CLICK, not on load, and the answer is
   cached per handle for the session. Browsing forty designs is forty small
   JSON reads on a warm CDN, and the grid itself is one 64 KB index fetched
   once.

   THE HANDLE CAN BE AN EXCEPTION. Most handles are slug + suffix, but a
   handful on this store do not follow the pattern, and the index records those
   per design at position 6. Guessing the handle and 404ing would put "add to
   cart" on a product that is not there, so the exception map wins.
*/
(function () {
  var PAGE = 24;

  /* THE FOUR INKS THE PRESS RUNS, with their measured contrast on this
     store's two grounds. A shopper picking a colour has to get a print they
     can read: pale yellow on a cream sack is a legitimate request and a bad
     product, so the choice is four inks rather than a wheel.

       on white   on pine
       -------    -------
       12.6:1     1.0:1   Deep Pine    #0E2B22
        2.1:1     6.4:1   Gold         #C2A049
        5.2:1     2.6:1   Christmas Red #9B2226
        1.0:1    13.1:1   White        #FFFFFF

     Which ones are OFFERED depends on the blank, so the list is filtered per
     product rather than shown whole: a white ink on a white mug is not a
     choice, it is a blank mug. */
  var INKS = [
    { key: 'Design',  hex: null,      label: 'As drawn' },
    { key: 'Pine',    hex: '#0E2B22', label: 'Deep pine' },
    { key: 'Gold',    hex: '#C2A049', label: 'Gold' },
    { key: 'Red',     hex: '#9B2226', label: 'Christmas red' },
    { key: 'White',   hex: '#FFFFFF', label: 'White' }
  ];

  var FACES = [
    { key: 'Bold',   css: '"Luckiest Guy", Impact, sans-serif', caps: true },
    { key: 'Comic',  css: '"Bangers", Impact, sans-serif',      caps: true },
    { key: 'Script', css: '"Great Vibes", cursive',                caps: false },
    { key: 'Clean',  css: '"Baloo 2", sans-serif',              caps: false }
  ];

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* The cdn prefix, factored out of every url in the index and put back here.
     656 rows carry two image urls each and all of them begin with the same 52
     characters; repeating it cost about 70 KB of json before the first tile
     drew. Set from the payload, with the store's own prefix as the fallback
     so an old cached index still resolves. */
  var CDN = 'https://cdn.shopify.com/s/files/1/0763/0274/5766/files/';

  function thumb(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) { u = 'https:' + u; }
    else if (u.indexOf('http') !== 0) { u = CDN + u; }
    /* THE WIDTH THAT WAS NEVER APPLIED. This used to test for a '?' and, on
       finding one, run a replace for an EXISTING width= parameter. Every
       Shopify url carries ?v=<epoch>, so the test always passed and the
       replace always matched nothing: the url went out untouched. Every tile
       asked for 300 px and every hero asked for 900, and all of them were
       served whatever the url already was. Append when it is absent. */
    // 0.27.0: drop the legacy "_600x" suffix, which pins the CDN to 600 px whatever width is asked.
    u = u.replace(/_(\d+x\d*|\d*x\d+)(?=\.(jpe?g|png|webp|gif)(\?|$))/i, '');
    if (/[?&]width=\d+/.test(u)) {
      return u.replace(/([?&])width=\d+/, '$1width=' + w);
    }
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* The eight printed grounds on the pet bandana, the same inks as the print
     files (0.22.0). Used for the name preview stage and the colour dots. */
  var BINK = { 'Red': '#A12A30', 'Black': '#202023', 'Navy': '#1E2C54', 'Green': '#1B5238',
    'Maroon': '#6A1C2C', 'Sky blue': '#8BC4E3', 'Pink': '#E291B2', 'Beige': '#DFD1B4' };

  /* 0.27.0 (audit M6): steps are numbered from what renders. A shelf that hides a step
     (mugs have no colour step) read 1, 3, 4 and looked like something was missing. */
  function renumber(root) {
    var n = 0;
    Array.prototype.slice.call(root.querySelectorAll('.sv-bd__step')).forEach(function (s) {
      var hidden = s.hidden || s.offsetParent === null || s.closest('[hidden]');
      var num = s.querySelector('span');
      if (!num) return;
      if (hidden) return;
      n += 1; num.textContent = n;
    });
  }

  function boot(root) {
    var kind = root.getAttribute('data-kind');
    var shelf = root.getAttribute('data-shelf') || '';
    var pickKind = !!root.getAttribute('data-pickkind');
    var lockAttr = (root.getAttribute('data-lock') || '').trim();
    var maxPrice = parseFloat(root.getAttribute('data-maxprice')) || 0;
    var who = (root.getAttribute('data-who') || '').trim().toLowerCase();
    var breed = (root.getAttribute('data-breed') || '').trim().toLowerCase();
    var st = { data: null, theme: null, design: null, shown: PAGE,
               prod: null, variant: null, face: FACES[0], ink: 'Design', cache: {},
               // A theme or recipient shelf LOCKS the artwork to itself. The
               // shopper standing on Baby's First Christmas who taps Beach
               // towels asked for baby designs on a towel; offering them 656
               // is answering a question they did not ask.
               lock: null };

    var els = {
      themes: $('[data-bd-themes]', root), grid: $('[data-bd-grid]', root),
      more: $('[data-bd-more]', root), opts: $('[data-bd-options]', root),
      faces: $('[data-bd-faces]', root), name: $('#sv-bd-name', root),
      chars: $('[data-bd-chars]', root), max: $('[data-bd-max]', root),
      add: $('[data-bd-add]', root), err: $('[data-bd-err]', root),
      img: $('[data-bd-img]', root), cap: $('[data-bd-cap]', root),
      pv: $('[data-bd-pv]', root), pvStage: $('[data-bd-pvstage]', root),
      pvArt: $('[data-bd-pvart]', root), pvName: $('[data-bd-pvname]', root),
      title: $('[data-bd-name]', root), price: $('[data-bd-price]', root),
      full: $('[data-bd-full]', root),
      kinds: $('[data-bd-kinds]', root),
      inks: $('[data-bd-inks]', root)
    };

    function drawInks() {
      if (!els.inks) return;
      // A white ink on a white blank is not a choice. The sack (white polyester
      // since 23 Sep 2026, Print Clever UK), the mug and the tee are white, so white is offered only where there is
      // something for it to sit on.
      var lightBlank = (kind === 'm' || kind === 't' || kind === 'k' || kind === 'w' || kind === 's' || kind === 'c');
      var list = INKS.filter(function (i) {
        return !(lightBlank && i.key === 'White');
      });
      els.inks.innerHTML = list.map(function (i, n) {
        var sw = i.hex || (st.design && st.design[9]) || '#0E2B22';
        return '<button type="button" class="sv-bd__ink' + (n === 0 ? ' is-on' : '') +
               '" data-ink="' + i.key + '" role="radio" aria-checked="' + (n === 0) +
               '" style="--i:' + sw + '"><span>' + esc(i.label) + '</span></button>';
      }).join('');
      $$('.sv-bd__ink', els.inks).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.sv-bd__ink', els.inks).forEach(function (o) {
            o.classList.toggle('is-on', o === b);
            o.setAttribute('aria-checked', o === b ? 'true' : 'false');
          });
          st.ink = b.getAttribute('data-ink');
          preview();
        });
      });
    }

    function inkHex() {
      if (!st.ink || st.ink === 'Design') {
        return (st.design && st.design[9]) || '#0E2B22';
      }
      var hit = INKS.filter(function (i) { return i.key === st.ink; })[0];
      return (hit && hit.hex) || '#0E2B22';
    }

    /* THE PRODUCT ROW, on /pages/create only. A picture of the mug, not a
       labelled box with a price: Tony, on the first version of that page,
       "stop trying to use text and give them collections ... showing all the
       different options a towel a cup, a hat, a shirt". */
    /* THE PRICE CAP. On /collections/gifts-under-50 the shopper has stated a
       budget, not a taste, so the row is the product types that FIT it and
       nothing else: ornament $29.95, mug $39.95, bandana $44.95. k[2] is that
       kind's cheapest variant including the base, computed in create_index,
       so it is the right number to test against. */
    function countFor(key) {
      var save = kind, n;
      kind = key;
      n = designs(null).length;
      kind = save;
      return n;
    }

    function kinds() {
      var all = (st.data.kinds || []).slice();
      if (maxPrice) {
        all = all.filter(function (k) { return parseFloat(k[2]) < maxPrice; });
      }
      /* A TILE THAT LEADS NOWHERE IS WORSE THAN NO TILE. On For Pets the
         bandana has 129 designs and the beach towel has none of them, so
         offering a towel tile there hands the shopper an empty grid. The count
         under each tile is the FILTERED count for the same reason: "656
         designs" on a shelf that will show 58 is the page contradicting
         itself, which is the fault the theme lock was built to stop. */
      return all.map(function (k) {
        var c = countFor(k[0]);
        return c ? [k[0], k[1], k[2], c, k[4]] : null;
      }).filter(Boolean);
    }

    /* PRODUCTS THAT TAKE A PHOTO, NOT A DESIGN (24 Sep 2026). A photo blanket
       is not in sv-designs.json because it carries the shopper's own photo, so
       the row never offered it. sv-build.liquid hands the tile over in
       data-extra (price and photo read from the live shelf) and it is drawn as
       a LINK to that shelf, where the upload lives. It is an <a>, so the
       button-only click binding below leaves it alone. */
    function extraKinds() {
      var raw = els.kinds && els.kinds.getAttribute('data-extra');
      if (!raw) return '';
      var list; try { list = JSON.parse(raw); } catch (e) { return ''; }
      return list.map(function (x) {
        return '<a class="sv-bd__kind sv-bd__kind--link" href="' + esc(x.u) + '" style="text-decoration:none">' +
               (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy" width="400" height="400">' : '<span class="sv-bd__kindnoimg"></span>') +
               '<span class="sv-bd__kindt">' + esc(x.t) + '</span>' +
               '<span class="sv-bd__kindp">from $' + esc(x.p) + '<span>' + esc(x.n) + '</span></span></a>';
      }).join('');
    }

    function drawKinds() {
      if (!els.kinds) return;
      els.kinds.innerHTML = kinds().map(function (k) {
        return '<button type="button" class="sv-bd__kind' +
               (k[0] === kind ? ' is-on' : '') + '" data-k="' + esc(k[0]) + '">' +
               (k[4] ? '<img src="' + esc(thumb(k[4], 400)) + '" alt="" loading="lazy" ' +
                       'width="400" height="400">' : '<span class="sv-bd__kindnoimg"></span>') +
               '<span class="sv-bd__kindt">' + esc(k[1]) + '</span>' +
               '<span class="sv-bd__kindp">from $' + esc(k[2]) +
               '<span>' + k[3] + ' designs</span></span></button>';
      }).join('') + extraKinds();
      $$('button.sv-bd__kind', els.kinds).forEach(function (b) {
        b.addEventListener('click', function () {
          kind = b.getAttribute('data-k');
          $$('.sv-bd__kind', els.kinds).forEach(function (o) {
            o.classList.toggle('is-on', o === b);
          });
          st.theme = null; st.shown = PAGE; st.design = null;
          drawThemes(); drawGrid();
          var list = designs(null);
          if (list.length) pick(list[0]);
        });
      });
    }

    /* ------------------------------------------------------------- data */
    /* THE ARTWORK FILTER, and it now answers to whatever the shelf is about
       rather than to the theme alone.

       Tony: "you cannot just fix one menu or one section, it has to be applied
       universally to every collection, every page, every search function". The
       shelf says four different things and all four are filters:

         kind    the product type, when the shelf or a cat: tag resolved one
         lock    the theme, when the shelf IS a theme or carries a theme: tag
         who     the recipient, on For Kids / For Her / For Him / For Pets
         breed   the breed, on /collections/pet-christmas/breed-kelpie

       A shelf that filters on none of them is /pages/create, where the shopper
       has said nothing yet. Every other shelf now says at least one. */
    function designs(theme) {
      return st.data.designs.filter(function (d) {
        if (d[4].indexOf(kind) < 0) return false;
        if (st.lock && d[2] !== st.lock) return false;
        if (theme && d[2] !== theme) return false;
        /* GUARDED ON PRESENCE, NOT ON TRUTH. A browser holding yesterday's
           cached sv-designs.json has ten columns, not twelve, so testing
           d[10] as a value would filter every design out and leave a shelf
           that looks broken for the twenty minutes the asset takes to
           propagate. An absent column means "this index cannot answer that
           question", which is not the same as "no design matches". */
        if (who && d.length > 10 &&
            (',' + (d[10] || '') + ',').indexOf(',' + who + ',') < 0) return false;
        if (breed && d.length > 11 && (d[11] || '') !== breed) return false;
        return true;
      });
    }
    function handleFor(d) {
      return (d[6] && d[6][kind]) || (d[5] + (st.data.sfx[kind] || ''));
    }

    /* ------------------------------------------------------------ chips */
    function drawThemes() {
      if (st.lock) {
        // One theme, so chips are pointless - but the shopper has to be able
        // to get back out, which is the fault the old shelf nav had.
        var name = (st.data.themes || []).filter(function (t) {
          return t[0] === st.lock; })[0];
        els.themes.hidden = false;
        els.themes.innerHTML =
          '<span class="sv-bd__lock">' +
          esc(name ? name[1] : st.lock) + ' designs only</span>' +
          '<button type="button" class="sv-bd__chip" data-t="">' +
          'Show all ' + st.data.designs.filter(function (d) {
            return d[4].indexOf(kind) >= 0; }).length + '</button>';
        var all = $('.sv-bd__chip', els.themes);
        if (all) all.addEventListener('click', function () {
          st.lock = null; st.theme = null; st.shown = PAGE;
          drawThemes(); drawGrid();
        });
        return;
      }
      var h = '<button type="button" class="sv-bd__chip is-on" data-t="">All ' +
              '<span>' + designs(null).length + '</span></button>';
      st.data.themes.forEach(function (t) {
        var n = designs(t[0]).length;
        if (!n) return;
        h += '<button type="button" class="sv-bd__chip" data-t="' + esc(t[0]) + '">' +
             esc(t[1].replace(/ Christmas$/, '').replace(/^Christmas /, '')) +
             ' <span>' + n + '</span></button>';
      });
      els.themes.innerHTML = h;
      $$('.sv-bd__chip', els.themes).forEach(function (b) {
        b.addEventListener('click', function () {
          st.theme = b.getAttribute('data-t') || null;
          $$('.sv-bd__chip', els.themes).forEach(function (o) {
            o.classList.toggle('is-on', o === b);
          });
          st.shown = PAGE;
          drawGrid();
        });
      });
    }

    /* ------------------------------------------------------------- grid */
    function drawGrid(append) {
      var list = designs(st.theme);
      if (!append) { els.grid.innerHTML = ''; }
      var from = append ? els.grid.children.length : 0;
      list.slice(from, st.shown).forEach(function (d, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sv-bd__tile' + (st.design && st.design[0] === d[0] ? ' is-on' : '');
        // pick() marks the selected tile by THIS attribute. It was set in the
        // click handler that got replaced, so for one deploy every tile had
        // dataset.d undefined and nothing was ever marked as chosen.
        b.dataset.d = d[0];
        b.title = d[1];
        // 0.50.0 (fixloop): the first two rows are on the first screen at desktop, so they load
        // straight away; lazy loading them held back the shelf's first paint.
        b.innerHTML = '<img src="' + esc(thumb(d[3], 180)) + '" alt="' + esc(d[1]) +
                      '" loading="' + (!append && i < 12 ? 'eager' : 'lazy') + '" width="300" height="300">';
        b.addEventListener('click', function () { pick(d); });
        els.grid.appendChild(b);
      });
      els.more.hidden = list.length <= st.shown;
      els.more.textContent = 'Show ' + Math.min(PAGE, list.length - st.shown) +
                             ' more of ' + list.length;
      if (!append) { window.requestAnimationFrame(topUp); }
    }

    /* SCROLLING THE GRID LOADS THE NEXT PAGE.
       Tony, on the All chip: "WHEN ITS ON ALL IT DOSENT SHOW ALL images maybe
       its too many?" - 656 designs at 24 a click is twenty seven presses of
       "Show more" to reach the end, which is the endless-click problem in a
       smaller box. The grid is its own scroller, so scrolling it near the
       bottom appends the next page. The button stays for anyone who does not
       scroll and for keyboard use; it is not the only way through.

       WHY NOT RENDER ALL 656 AT ONCE. Six hundred and fifty six <img> tags
       lock a mid range phone for well over a second on first paint even
       lazily, and the shopper is looking at the product while it happens. */
    function onGridScroll() {
      var g = els.grid;
      if (!g) return;
      if (g.scrollTop + g.clientHeight < g.scrollHeight - 220) return;
      var list = designs(st.theme);
      if (st.shown >= list.length) return;
      st.shown += PAGE;
      drawGrid(true);
      topUp();
    }

    /* A GRID THAT DOES NOT SCROLL NEVER FIRES A SCROLL EVENT.
       24 tiles in five columns is about 420 px inside a 470 px box, so the
       first page fits, scrollHeight equals clientHeight, and the lazy loader
       sat waiting for an event the browser had no reason to send. Measured,
       not assumed: six programmatic scrolls to the bottom left the count at
       24 of 656.

       So after every draw, keep appending while the box is not scrollable and
       there is more to show. The cap is there because a wide monitor with a
       short grid could otherwise walk the whole 656 in one go, which is the
       lock-up this paging exists to avoid. */
    function topUp() {
      var g = els.grid;
      if (!g) return;
      var guard = 0;
      while (guard++ < 6 &&
             g.scrollHeight <= g.clientHeight + 8 &&
             st.shown < designs(st.theme).length) {
        st.shown += PAGE;
        drawGrid(true);
      }
    }

    /* ------------------------------------------------------------- pick */
    function pick(d) {
      st.design = d;
      // MARK BY ID, NOT BY INDEX. drawGrid also marks the selected tile, by id,
      // and this marked it a second time by its position in the FILTERED list.
      // The two agree until the shopper changes the theme chip, after which the
      // index points at a different tile and two designs show as chosen at
      // once, which on a picker is worse than none being chosen.
      $$('.sv-bd__tile', els.grid).forEach(function (t) {
        t.classList.toggle('is-on', t.dataset.d === String(d[0]));
      });

      // The design index's image is the ARTWORK, drawn flat. On a Santa Sack
      // shelf that put a picture of a graphic where the sack should be, which
      // is the exact complaint that started this: do not advertise the artwork,
      // advertise the thing being sold. It is used only as the placeholder
      // while the product's own photograph loads, and `apply` replaces it.
      els.img.src = thumb(d[3], 900);
      els.img.alt = d[1];
      els.title.textContent = d[1];
      els.cap.textContent = d[1];

      var h = handleFor(d);
      els.full.href = '/products/' + h;
      var asDrawn = els.inks && $('.sv-bd__ink[data-ink="Design"]', els.inks);
      if (asDrawn) asDrawn.style.setProperty('--i', (d && d[9]) || '#0E2B22');
      els.add.disabled = true;
      els.add.textContent = 'Loading…';
      load(h);
    }

    function load(h) {
      if (st.cache[h]) { apply(st.cache[h]); return; }
      fetch('/products/' + h + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('404');
          return r.json();
        })
        .then(function (j) { st.cache[h] = j; apply(j); })
        .catch(function () {
          // A handle that does not resolve is a catalogue problem, not a
          // shopper problem. Say so and offer the shelf rather than leaving
          // a dead button.
          els.add.textContent = 'Not available';
          els.add.disabled = true;
          fail('That design is not on this product at the moment. Try another, ' +
               'or open its own page.');
        });
    }

    function apply(j) {
      st.prod = j;
      fail(null);
      // THE PRODUCT'S OWN PHOTOGRAPH, which is this design ON this blank.
      var shot = j.featured_image || (j.images && j.images[0]);
      if (shot) {
        // The server already painted this product's photograph: keep it rather than
        // download the same picture again from another host.
        var keep = els.img.getAttribute('data-bd-handle') === j.handle && els.img.getAttribute('src');
        if (!keep) {
          els.img.removeAttribute('srcset');
          els.img.removeAttribute('sizes');
          els.img.src = thumb(shot.indexOf('//') === 0 ? 'https:' + shot : shot, 1000);
        }
        els.img.removeAttribute('data-bd-handle');
        els.img.alt = j.title;
      }
      els.title.textContent = j.title;
      // On /pages/create there is no collection, so data-title is empty and
      // the caption read ", printed to order" with nothing in front of it.
      // Fall back to the product's own type.
      var ctx = (root.getAttribute('data-title') || '').trim() ||
                (j.type ? j.type + 's' : '');
      els.cap.textContent = ctx ? (ctx + ', printed to order') : 'Printed to order';
      els.price.textContent = money(j.price);
      setMax(j.type);
      drawOptions();
      renumber(root);
      resolve();
      preview();
    }

    /* 0.27.0 (audit M6): the name limit is the product type's, the same number the product
       page states and the press was set up for. The builder used to allow 14 on everything,
       so a 13 letter name on a mug or a 12 letter name on an ornament could be ordered and
       then print smaller than the page promised. */
    var MAXC = { 'Mug': 12, 'Santa Sack': 12, 'Christmas Stocking': 10, 'Kids T-Shirt': 12, 'T-Shirt': 14,
                 'Beach Towel': 14, 'Ornament': 10, 'Pet Bandana': 10 };
    function setMax(type) {
      var m = MAXC[type] || 12;
      els.name.setAttribute('maxlength', m);
      if (els.max) els.max.textContent = m;
      if ((els.name.value || '').length > m) {
        els.name.value = els.name.value.slice(0, m);
      }
      els.chars.textContent = (els.name.value || '').length;
    }

    /* ---------------------------------------------------------- options
       The options come off the PRODUCT, not off a list in here. A sack has
       one size, a tee has size and colour, a bandana has three cuts. Writing
       that out per kind is how it goes stale the first time a blank changes. */
    function drawOptions() {
      var j = st.prod;
      var real = (j.options || []).filter(function (o) {
        return (o.values || o).length > 1;
      });
      if (!real.length) { els.opts.innerHTML = ''; return; }
      // "2 size" reads like a typo. The option names come off the product so
      // they can be Size, Colour, Style; "The size and colour" is the sentence.
      var h = '<div class="sv-bd__step"><span>2</span> The ' +
              real.map(function (o) { return esc(String(o.name || o).toLowerCase()); })
                  .join(' and ') + '</div>';
      (j.options || []).forEach(function (o, i) {
        var name = o.name || o;
        var vals = o.values || [];
        if (vals.length < 2) return;
        h += '<div class="sv-bd__opt" data-oi="' + i + '">' +
             '<span class="sv-bd__lab">' + esc(name) + '</span><div class="sv-bd__vals">';
        /* SOLD OUT SHOWS AS SOLD OUT BEFORE THE CLICK, rather than the add
           button saying it only after a value was chosen. Struck through the
           way the product page's own picker does it, still clickable so the
           shopper can see the value exists. A value counts as sold out when NO
           available variant carries it at this option's position, which is the
           right test whatever the number of options: the old test only ran on
           one-option products, so the moment the bandana gained a colour it
           would have stopped marking anything. Opens on the first value that
           can be bought. */
        if (!document.getElementById('sv-out-css')) {
          var oc = document.createElement('style');
          oc.id = 'sv-out-css';
          oc.textContent = '.sv-bd__val.is-out{text-decoration:line-through;opacity:.55}' +
            '.sv-vh{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}';
          document.head.appendChild(oc);
        }
        var outs = vals.map(function (v) {
          return !j.variants.some(function (x) { return x.options[i] === v && x.available; });
        });
        var first = Math.max(0, outs.indexOf(false));
        /* THE SHOPPER'S PICK SURVIVES A CHANGE OF ARTWORK. Tony: "if you load a
           different artwork it resets the shirt back to default, it should stay
           at the size they have selected as they may want to just add multiples
           with different art same size". Every design is its own product, so
           each pick used to redraw the options from scratch. What the shopper
           clicked is kept by option NAME and reapplied whenever this product
           offers that value, so an XL tee in navy stays an XL tee in navy
           across designs, and a size carries from tee to hoodie where it exists. */
        var kept = st.pick && st.pick[String(name).toLowerCase()];
        if (kept != null && vals.indexOf(kept) > -1) first = vals.indexOf(kept);
        vals.forEach(function (v, n) {
          h += '<button type="button" class="sv-bd__val' + (n === first ? ' is-on' : '') +
               (outs[n] ? ' is-out' : '') + '" data-v="' + esc(v) + '"' +
               (outs[n] ? ' title="Sold out"' : '') + '>' +
               (String(name) === 'Bandana colour' && BINK[v] ?
                 '<span aria-hidden="true" style="display:inline-block;width:.95em;height:.95em;border-radius:50%;background:' +
                 BINK[v] + ';margin-right:.45em;vertical-align:-.12em;box-shadow:inset 0 0 0 1px rgba(0,0,0,.28)"></span>' : '') +
               esc(v) +
               (outs[n] ? '<span class="sv-vh"> (sold out)</span>' : '') + '</button>';
        });
        h += '</div></div>';
      });
      els.opts.innerHTML = h;
      $$('.sv-bd__val', els.opts).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.sv-bd__val', b.parentNode).forEach(function (o) {
            o.classList.toggle('is-on', o === b);
          });
          var row = b.closest('.sv-bd__opt');
          var lab = row && $('.sv-bd__lab', row);
          if (lab) {
            st.pick = st.pick || {};
            st.pick[lab.textContent.trim().toLowerCase()] = b.getAttribute('data-v');
          }
          resolve();
        });
      });
    }

    function chosen() {
      return $$('.sv-bd__opt', els.opts).map(function (row) {
        var on = $('.sv-bd__val.is-on', row);
        return on ? on.getAttribute('data-v') : null;
      });
    }

    /* THE VARIANT IS RESOLVED, NOT ASSUMED. A product with one option that has
       one value still has a variant, and a product whose chosen combination is
       sold out must not be addable. Both come off the product JSON. */
    function resolve() {
      var j = st.prod;
      if (!j) return;
      var picked = chosen();
      var hit = null;
      if (!picked.length) {
        hit = j.variants.filter(function (v) { return v.available; })[0] || j.variants[0];
      } else {
        var wanted = [];
        var k = 0;
        (j.options || []).forEach(function (o) {
          var vals = o.values || [];
          wanted.push(vals.length > 1 ? picked[k++] : vals[0]);
        });
        hit = j.variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === wanted[i]; });
        })[0];
      }
      st.variant = hit || null;
      garment();
      vshot();
      if (!hit) { els.add.disabled = true; els.add.textContent = 'Not available'; return; }
      els.price.textContent = money(hit.price);
      els.add.disabled = !hit.available;
      els.add.textContent = hit.available ? 'Add to cart' : 'Sold out';
      root.dispatchEvent(new Event('sv:state'));   // 0.31.0: the set box redraws
    }

    /* THE CHOSEN GARMENT IN THE CHOSEN COLOUR. Tony: "when ordering
       different colour items the item preview colour needs to show that
       colour and also the product changes t shirt hoodie etc". The product's
       own photograph is a WHITE tee; sv-garment.js draws the provider's photo
       of the garment actually chosen, with this design in its print box and
       the name as typed, over it. */
    /* THE PICKED VARIANT'S OWN PHOTO. 0.22.2. Tony: "pet bandanas still not
       changing colour when building". garment() only answers options named
       Style or Colour, so the bandana's "Bandana colour" never moved the image
       and the big picture stayed on the red tie-on whatever was chosen. Any
       product that is not a garment now shows the chosen variant's own
       photograph, and a bandana's name preview sits on the chosen ground. */
    function vshot() {
      var j = st.prod, v = st.variant;
      if (!j || !els.img) return;
      var names = (j.options || []).map(function (o) { return String(o.name || o); });
      var bi = names.indexOf('Bandana colour');
      if (els.pvStage) els.pvStage.style.backgroundColor = v && bi >= 0 ? (BINK[v.options[bi]] || '') : '';
      if (!v || names.indexOf('Style') >= 0 || names.indexOf('Colour') >= 0) return;
      var fi = v.featured_image; fi = fi && (fi.src || fi);
      if (typeof fi !== 'string' || !fi) return;
      var t = thumb(fi.indexOf('//') === 0 ? 'https:' + fi : fi, 1000);
      if (els.img.getAttribute('src') !== t) els.img.src = t;
      els.img.alt = j.title + (v.title ? ', ' + v.title : '');
    }

    function garment() {
      var j = st.prod, d = st.design;
      var host = els.img && els.img.parentNode;
      var old = host && host.querySelector('canvas.sv-gcv');
      var names = (j && j.options || []).map(function (o) { return o.name || o; });
      var si = names.indexOf('Style'), ci = names.indexOf('Colour');
      if (!window.SVGarment || !j || !d || !d[7] || (si < 0 && ci < 0) || !host) {
        if (old) old.remove();
        return;
      }
      var v = st.variant || j.variants[0];
      var c = old;
      if (!c) {
        c = document.createElement('canvas');
        c.className = 'sv-gcv';
        c.setAttribute('aria-hidden', 'true');
        host.appendChild(c);
      }
      // over the PHOTO, not the whole figure: the figure also holds the caption
      var im = els.img;
      c.style.cssText = 'inset:auto;top:' + im.offsetTop + 'px;left:' + im.offsetLeft +
        'px;width:' + im.offsetWidth + 'px;height:' + im.offsetHeight + 'px';
      var nm = els.name ? els.name.value : '';
      var art = thumb(d[7], 900);
      // Kept so the cart can draw the same garment again (sv-garment.js).
      st.gopts = {
        m: root.getAttribute('data-garments'),
        s: si >= 0 ? v.options[si] : (j.type === 'Kids T-Shirt' ? 'Kids Tee' : 'Tee'),
        c: ci >= 0 ? v.options[ci] : 'White',
        a: art, i: inkHex() || d[9] || '#0E2B22',
        f: st.face.css, k: st.face.caps, l: d[8] || 'hero'
      };
      window.SVGarment.draw({
        canvas: c, manifest: st.gopts.m, style: st.gopts.s, colour: st.gopts.c,
        art: art, name: nm, ink: st.gopts.i,
        font: st.gopts.f, caps: st.gopts.k, slot: st.gopts.l
      }).catch(function () { if (c) c.remove(); });
    }

    /* ------------------------------------------------------------ faces */
    function drawFaces() {
      els.faces.innerHTML = FACES.map(function (f, i) {
        // THE FACE NAMES CONTAIN DOUBLE QUOTES ('"Great Vibes", cursive') and
        // this was building style="font-family:"Great Vibes", cursive", which
        // the parser terminates at the first inner quote. Every face button
        // has been rendering in Arial since it was written, so the row that
        // shows the shopper what each lettering looks like showed them
        // nothing. Escape it, and verify with getComputedStyle rather than by
        // looking at the source.
        return '<button type="button" class="sv-bd__face' + (i === 0 ? ' is-on' : '') +
               '" data-f="' + f.key + '" style="font-family:' +
               f.css.replace(/"/g, '&quot;') + '" ' +
               'role="radio" aria-checked="' + (i === 0) + '">' +
               (f.caps ? f.key.toUpperCase() : f.key) + '</button>';
      }).join('');
      $$('.sv-bd__face', els.faces).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.sv-bd__face', els.faces).forEach(function (o) {
            o.classList.toggle('is-on', o === b);
            o.setAttribute('aria-checked', o === b ? 'true' : 'false');
          });
          st.face = FACES.filter(function (f) { return f.key === b.getAttribute('data-f'); })[0];
          preview();
        });
      });
    }

    function fail(msg) {
      els.err.hidden = !msg;
      if (msg) els.err.textContent = msg;
    }

    /* 0.31.0: sv-set.js builds the sack and stocking set from what is chosen here (snippets/sv-set.liquid). */
    root.svSetState = function () {
      return { kind: kind, design: st.design, handle: st.design ? handleFor(st.design) : '', variant: st.variant,
               sfx: st.data && st.data.sfx, name: (els.name.value || '').trim(), face: st.face && st.face.key, ink: st.ink };
    };

    /* -------------------------------------------------------------- add */
    els.add.addEventListener('click', function () {
      if (!st.variant) return;
      var props = {};
      var nm = (els.name.value || '').trim();
      // A BLANK NAME SENDS NO PROPERTY AT ALL rather than an empty one, or the
      // press is handed a blank to set and the packing slip reads "Name:".
      if (nm) {
        props['Name'] = nm;
        props['Lettering'] = st.face.key;
        // Only send a colour when it is NOT the design's own ink, so the
        // packing slip stays quiet unless the shopper actually changed it.
        if (st.ink && st.ink !== 'Design') props['Lettering colour'] = st.ink;
      }
      // THE CART SHOWS WHAT WAS ORDERED: the garment in its colour with this
      // artwork and name, redrawn from this hidden property by sv-garment.js.
      if (st.gopts && st.prod && st.gopts.s) {
        var gv = st.variant, names = (st.prod.options || []).map(function (o) { return o.name || o; });
        var gp = {}; for (var gk in st.gopts) gp[gk] = st.gopts[gk];
        var gsi = names.indexOf('Style'), gci = names.indexOf('Colour');
        if (gsi >= 0) gp.s = gv.options[gsi];
        if (gci >= 0) gp.c = gv.options[gci];
        gp.n = nm;
        props['_sv_preview'] = JSON.stringify(gp);
      }
      els.add.disabled = true;
      els.add.textContent = 'Adding…';
      root.svAddLines([{ id: st.variant.id, quantity: 1, properties: props }],
                      (nm || 'No name') + ', ' + (st.design ? st.design[1] : '') + ' ' + kindLabel())
        .catch(function (e) {
          els.add.disabled = false;
          els.add.textContent = 'Add to cart';
          fail('That could not be added: ' + String(e.message || e).slice(0, 90));
        });
    });

    /* ---------------------------------------------- FAMILY ORDERS (store 0.36.0)
       Tony, 24 Sep 2026: "they need to be able to order different graphics with multiple sets nobody wants 4
       bags named the same etc everything must be able to be individually customised. also the % buttons dont
       work". The builder used to send the shopper to the cart after every single add, so a family of four meant
       four trips back to the shelf. Now an add keeps them here: the name clears, the artwork stays open for the
       next person's design, and a strip says who is in the cart and what the multi-buy is taking off. The %
       chips (sv-multibuy.liquid) set how many people they are buying for, and the step reads "Person 2 of 4". */
    var PERSO_TYPES = ['T-Shirt', 'Kids T-Shirt', 'Mug', 'Santa Sack', 'Christmas Stocking', 'Pet Bandana',
                       'Ornament', 'Beach Towel', 'Blanket'];
    var fam = { target: 0, added: [] };
    function kindLabel() {
      var k = (st.data && st.data.kinds || []).filter(function (x) { return x[0] === kind; })[0];
      return k ? k[1].toLowerCase() : '';
    }
    function tiersNow() { return (window.SV_MB || []).slice().sort(function (a, b) { return a[0] - b[0]; }); }
    function pctFor(n) { var p = 0; tiersNow().forEach(function (t) { if (n >= t[0]) p = t[1]; }); return p; }
    function nextFor(n) { var t = tiersNow(); for (var i = 0; i < t.length; i++) if (t[i][0] > n) return t[i]; return null; }
    var whoEl = document.createElement('p');
    whoEl.className = 'sv-bd__who'; whoEl.hidden = true;
    els.name.parentNode.insertBefore(whoEl, els.name.previousElementSibling || els.name);
    var done = document.createElement('div');
    done.className = 'sv-bd__done'; done.hidden = true; done.setAttribute('aria-live', 'polite');
    els.err.parentNode.insertBefore(done, els.err.nextSibling);
    function drawWho() {
      var n = fam.added.length + 1;
      if (fam.target > 1 && n <= fam.target) {
        whoEl.hidden = false;
        whoEl.innerHTML = '<b>Person ' + n + ' of ' + fam.target + '</b>: pick their design above, then type their name.';
      } else if (fam.added.length) {
        whoEl.hidden = false;
        whoEl.innerHTML = '<b>Next person</b>: pick their design above, then type their name.';
      } else whoEl.hidden = true;
    }
    root.svTarget = function (n) {
      fam.target = n; drawWho();
      (whoEl.hidden ? els.name : whoEl).scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (!fam.added.length) els.name.focus({ preventScroll: true });
    };
    function drawDone(cart) {
      var items = (cart.items || []).filter(function (i) { return PERSO_TYPES.indexOf(i.product_type) >= 0; });
      var n = items.reduce(function (a, i) { return a + i.quantity; }, 0);
      var pct = pctFor(n), nx = nextFor(n);
      var list = fam.added.map(function (a) { return '<li>' + esc(a) + '</li>'; }).join('');
      var left = fam.target > 1 ? fam.target - fam.added.length : 0;
      done.hidden = false;
      done.innerHTML = '<p class="sv-bd__done-h"><b>Added.</b> ' + n + ' personalised ' + (n === 1 ? 'item' : 'items') +
        ' in your cart' + (pct ? ', <b>' + pct + '% off</b> each' : '') + '.' +
        (nx ? ' Add ' + (nx[0] - n === 1 ? 'one more' : (nx[0] - n) + ' more') + ' for ' + nx[1] + '% off every one.' : '') + '</p>' +
        '<ol class="sv-bd__done-l">' + list + '</ol>' +
        '<div class="sv-bd__done-b">' +
          (left > 0 ? '<button type="button" class="sv-bd__next" data-bd-next>Next person (' + left + ' to go)</button>'
                    : '<button type="button" class="sv-bd__next" data-bd-next>Add someone else</button>') +
          '<a class="sv-bd__cart" href="/cart">Go to cart</a></div>';
      done.querySelector('[data-bd-next]').addEventListener('click', function () {
        drawWho();
        var art = els.themes || els.grid || els.name;
        art.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    }
    root.svAddLines = function (lines, label) {
      var resolveH, p = new Promise(function (r) { resolveH = r; });
      var ev = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: false });
      ev.action = 'add'; ev.context = 'product'; ev.promise = p;
      ev.lines = lines.map(function (l) { return { merchandiseId: 'gid://shopify/ProductVariant/' + l.id, quantity: l.quantity || 1 }; });
      root.dispatchEvent(ev);
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lines })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { resolveH({ detail: { didError: true } }); throw new Error(res.j && res.j.description || 'failed'); }
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          resolveH({ cart: { totalQuantity: cart.item_count }, detail: { didError: false, itemCount: cart.item_count, items: cart.items, source: 'sv-build' } });
          fam.added.push(label);
          els.name.value = '';
          els.name.dispatchEvent(new Event('input', { bubbles: true }));
          els.add.disabled = !(st.variant && st.variant.available);
          els.add.textContent = 'Add to cart';
          drawDone(cart);
          drawWho();
          done.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          return cart;
        });
    };

    /* ------------------------------------------------------- print preview
       The product photograph has a SAMPLE name printed into it. A shopper who
       types Olivia and is still looking at "YOUR NAME" has been shown the
       wrong product, which is the complaint that produced the product page's
       preview in the first place. Image two is the clean artwork, rendered
       with no name on it, so the real one can be laid under it in the face
       they chose and the ink the press uses - both of which now travel in the
       design index, because /products/<handle>.js carries no metafields. */
    function preview() {
      garment();
      var nm = (els.name.value || '').trim();
      var d = st.design, j = st.prod;
      /* THE WHITE SQUARE. d[7] is the design's own cut-out PNG, alpha intact,
         trimmed to the drawing. The product's second image is a JPEG and a
         JPEG has no alpha, so using it put every design on a white rectangle
         and told the shopper a box would print. Nothing was ever going to
         print a box - the press files are RGBA - but the preview has to say
         so. The JPEG stays as the fallback for a design whose cut-out has not
         published yet: a slightly wrong preview beats no preview. */
      var art = (d && d[7]) ||
                (j && j.images && j.images.length > 1 ? j.images[1] : null);
      if (!nm || !art) { els.pv.hidden = true; return; }
      els.pv.hidden = false;
      var url = art.indexOf('//') === 0 ? 'https:' + art : art;
      if (els.pvArt.getAttribute('data-src') !== url) {
        els.pvArt.src = thumb(url, 700);
        els.pvArt.setAttribute('data-src', url);
      }
      els.pvStage.setAttribute('data-slot', kind === 'c' ? 'above' : ((d && d[8]) || 'hero'));   // the stocking prints the name across the top
      els.pvName.textContent = st.face.caps ? nm.toUpperCase() : nm;
      els.pvName.style.color = inkHex();
      els.pvName.style.fontFamily = st.face.css;
      /* Only go to a dark card when the artwork is a CUT-OUT. A JPEG on a
         dark card is a glaring white rectangle; on the white card it was at
         least invisible. So the card follows the asset, not just the ink. */
      els.pvStage.classList.toggle('is-light',
                                   isLight(inkHex()) && !!(d && d[7]));
      // Fit it the way the renderer does: shrink until it fits, keep air.
      var box = els.pvStage.clientWidth * 0.92;
      if (!box) return;
      var size = Math.round(els.pvStage.clientHeight * 0.17);
      els.pvName.style.fontSize = size + 'px';
      var guard = 0;
      while (els.pvName.scrollWidth > box && size > 9 && guard++ < 60) {
        size -= 1;
        els.pvName.style.fontSize = size + 'px';
      }
      els.pvName.style.textShadow = keylines(size, inkHex());
    }

    /* ---------------------------------------------------- THE WHITE NAME
       Tony, looking at a sack: "white text dosent preview on santa sacks".
       It never could. The preview drew the name as FLAT COLOUR on a white
       card, so white ink was white on white. Worse, that was wrong for every
       other colour too, because the press does not print flat colour.

       tools/personalise.py draw_name() lays THREE passes down, in this order:
         1. charcoal (14,22,28) at stroke_width  sw * 2.1
         2. white     at stroke_width  sw
         3. the ink colour itself, no stroke
       with sw = font.size * 0.085. That is what makes a name read on a cream
       sack AND a black hoodie. The preview has to draw the same two rings or
       it is not a preview, it is a different product.

       CSS gives one -webkit-text-stroke, not two, so the rings are built out
       of offset text-shadows. Shadows paint FIRST-ON-TOP, so the white ring
       is listed before the charcoal one, and both sit behind the glyph. */
    function ring(r, hex) {
      var out = [], n = 16, i, t;
      for (i = 0; i < n; i++) {
        t = i * 2 * Math.PI / n;
        out.push((Math.cos(t) * r).toFixed(2) + 'px ' +
                 (Math.sin(t) * r).toFixed(2) + 'px 0 ' + hex);
      }
      return out;
    }

    function keylines(size, ink) {
      var key = Math.max(1, size * 0.085);
      var out = Math.max(key + 1, size * 0.1785);
      /* THE WHITE INK CASE. A white keyline under a white ink dilates the
         glyphs by 8.5 per cent and then fills them the same colour, so the
         letters fuse into one slug. That is not a preview artefact: rendered
         out of tools/personalise.py, DANNY in white came back as a blob with
         no letterforms in it, which is what the press would have printed. The
         renderer now inverts the two rings for a light ink - charcoal keyline
         to cut the letter out, light halo to hold it off a dark ground - and
         this draws the same inversion so the preview still matches the file. */
      var a = '#FFFFFF', b = '#0E161C';
      if (isLight(ink)) { a = '#0E161C'; b = '#FFFFFF'; }
      return ring(key, a).concat(ring(out, b)).join(',');
    }

    /* A light ink needs the card behind it darkened as well, because the ring
       alone still leaves a pale name on a pale ground once it is small. */
    function isLight(hex) {
      var h = String(hex).replace('#', '');
      if (h.length === 3) { h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2]; }
      var n = parseInt(h, 16);
      if (isNaN(n)) return false;
      return (((n >> 16 & 255) * 299 + (n >> 8 & 255) * 587 + (n & 255) * 114) / 1000) > 186;
    }

    els.name.addEventListener('input', function () {
      els.chars.textContent = (els.name.value || '').length;
      preview();
    });

    if (els.grid) {
      var ticking = false;
      els.grid.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; onGridScroll(); });
      }, { passive: true });
    }
    if (els.more) {
      els.more.addEventListener('click', function () {
        st.shown += PAGE; drawGrid(true);
      });
    }

    /* ------------------------------------------------------------- init */
    fetch(root.getAttribute('data-src'))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        st.data = j;
        if (j.cdn) { CDN = j.cdn; }
        /* A price shelf opens ON the cheapest product that fits. /pages/create
           deliberately opens with nothing chosen because the shopper has said
           nothing yet; a shopper on Under $50 has, and an empty stage under a
           row of three tiles reads as a broken page rather than a choice. */
        /* A CAT CHIP CAN BREAK THE BUDGET. On Under $50 the shelf nav offers
           "Beach towels", because 28 STOCKED towels under $50 sit on that
           shelf. The cat tag resolves to the personalised towel, which is
           $54.95. Rendering the builder there would answer a shopper who
           asked for under fifty with a fifty-five dollar product. Stand down
           and let the grid of stocked goods do its job. */
        if (maxPrice && kind) {
          var cur = (j.kinds || []).filter(function (k) {
            return k[0] === kind;
          })[0];
          if (cur && parseFloat(cur[2]) >= maxPrice) {
            root.hidden = true; unwait();
            return;
          }
        }
        // If this shelf IS a theme, lock the artwork to it. Index position
        // 3 on a theme row is that theme's collection handle.
        // A `theme:` tag in the URL is the shopper's own choice and wins over
        // the shelf's, because it is the later and narrower statement.
        (j.themes || []).forEach(function (t) {
          if (t[3] && t[3] === shelf) st.lock = t[0];
        });
        if (lockAttr) {
          var hit = (j.themes || []).filter(function (t) { return t[0] === lockAttr; })[0];
          if (hit) st.lock = hit[0];
        }
        /* AFTER THE LOCK, NOT BEFORE. Choosing the opening product type means
           counting the artwork that survives every filter, and the theme lock
           is one of those filters. Run this above and For Pets opens on the
           tee because the tee has the most designs overall, then draws an
           empty grid because none of them are pet designs. */
        if (!kind) {
          var fit = kinds();
          if (fit.length) {
            fit = fit.slice().sort(maxPrice
              ? function (a, b) { return parseFloat(a[2]) - parseFloat(b[2]); }
              : function (a, b) { return b[3] - a[3]; });
            kind = fit[0][0];
          }
        }
        var k = (j.kinds || []).filter(function (x) { return x[0] === kind; })[0];
        if (!k || !designs(null).length) {
          // A lock with nothing behind it is a shelf with no designs of this
          // type. Drop the lock rather than show an empty builder.
          if (st.lock) { st.lock = null; }
          if (!k || !designs(null).length) { root.hidden = true; unwait(); return; }
        }
        root.classList.add('is-ready');
        document.documentElement.classList.add('sv-has-builder');
        // TWO IDENTICAL CHIP ROWS IS WORSE THAN NONE. sv-shelf-nav renders
        // "BROWSE BY DESIGN" as links that reload the page; the builder's own
        // chips filter in place. Keeping both left the shelf with 23 chips
        // above 23 chips doing different things, which is how a shopper stops
        // trusting a page. The recipient row is a different axis and stays.
        // THE DUPLICATE CHIP ROW. sv-shelfnav renders "Browse by design" as
        // links that RELOAD the page; the builder's own chips filter in place
        // and now also honour the tag in the url. Two rows doing the same job
        // and disagreeing about the answer is worse than either alone, so the
        // page-reloading one goes. `hidden` is not enough on its own because
        // the theme's CSS sets a display on the row, so both are set.
        Array.prototype.forEach.call(
          document.querySelectorAll('.sv-shelfnav__row'), function (row) {
            var lab = row.querySelector('.sv-shelfnav__lab');
            if (lab && /browse by design/i.test(lab.textContent || '')) {
              row.hidden = true;
              row.style.display = 'none';
            }
          });
        drawKinds();
        drawThemes();
        drawGrid();
        drawFaces();
        drawInks();
        var first = designs(null)[0];
        var ih = els.img && els.img.getAttribute('data-bd-handle');
        if (ih) {
          var same = designs(null).filter(function (d) { return handleFor(d) === ih; })[0];
          if (same) first = same;
        }
        pick(first);
        fold(designs(null).length);
        unwait();
      })
      .catch(function () { root.hidden = true; unwait(); });
  }

  /* THE FULL GRID, FOLDED RATHER THAN REMOVED.
     653 tiles that all say "Personalised Santa Sack $69.95" are not a shelf a
     person can use, and they ARE 653 internal links Google already has. So the
     grid stays in the document and stops being the first thing a human meets.
     Done in JS against the section that actually contains the grid, rather
     than with a :has() selector guessed at the section's id, because the id is
     generated by Shopify and changes. */
  function fold(n) {
    var grid = document.querySelector('.product-grid');
    var sec = grid && grid.closest('.shopify-section');
    if (!sec || sec.dataset.svFold) return;
    sec.dataset.svFold = '1';
    var bar = document.createElement('div');
    bar.className = 'sv-bd__browse';
    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = 'Or browse all ' + n + ' as a list';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var open = sec.classList.toggle('sv-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.textContent = open ? 'Hide the full list'
                           : 'Or browse all ' + n + ' as a list';
      if (open) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    bar.appendChild(b);
    sec.parentNode.insertBefore(bar, sec);
    /* Tony, 22 Sep 2026, on /collections/pet-christmas?page=6: "how can there
       be this many pages for bandanas". The fold hid only the tiles; Horizon's
       filter bar ("130 items", Sort) and its page numbers sat outside it, so one
       bandana read as six pages of them. They fold with the list now. Hidden,
       not removed: the page links stay in the HTML, so Google still reaches
       every design. Written here rather than in santas-vault.css so it lives
       with the fold it belongs to. */
    sec.classList.add('sv-fold');
    if (!document.getElementById('sv-fold-css')) {
      var st = document.createElement('style');
      st.id = 'sv-fold-css';
      /* 0.28.2: the phone Filter button (.facets-toggle) and the per-page
         pickers were left showing with the list folded. The button opened a
         drawer that the rule above keeps display:none, so it did nothing, and
         the two "Show 24 50 100" rows sat stacked with no list between them.
         They fold with the list too. */
      st.textContent = '.shopify-section.sv-fold:not(.sv-open) .facets-block-wrapper,' +
        '.shopify-section.sv-fold:not(.sv-open) .facets-mobile-wrapper,' +
        '.shopify-section.sv-fold:not(.sv-open) .facets-toggle,' +
        '.shopify-section.sv-fold:not(.sv-open) .sv-perpage,' +
        '.shopify-section.sv-fold:not(.sv-open) .pagination{display:none}';
      document.head.appendChild(st);
    }
    /* Page 2 onwards of the folded list: the shopper opened the list and
       clicked a page number, so arriving with it folded shut again meant
       clicking "browse all" on every page (22 Sep 2026). */
    var pg = parseInt(new URLSearchParams(location.search).get('page') || '1', 10);
    if (pg > 1) {
      sec.classList.add('sv-open');
      b.setAttribute('aria-expanded', 'true');
      b.textContent = 'Hide the full list';
    }
  }


  /* NO JUMP ON ARRIVAL, 23 Sep 2026 (0.25.0). The builder used to be
     display:none until its design index arrived, three to six seconds on a
     phone, while the full product grid sat in its place; then the builder
     appeared and the grid folded, and the whole page jumped. Lighthouse
     measured layout shift at 0.29 to 0.34 on the product shelves and 0.97 on
     /pages/create, against a 0.1 target. sv-build.liquid now reserves the
     builder's space from the first paint and holds the grid folded
     (html.sv-bd-wait); this releases that hold on every exit, ready or stood
     down, so a shelf the builder declines still shows its grid. */
  function unwait() {
    document.documentElement.classList.remove('sv-bd-wait');
  }

  function start() {
    var r = document.querySelector('[data-sv-build]');
    if (r && !r.dataset.svOn) { r.dataset.svOn = '1'; boot(r); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
  document.addEventListener('shopify:section:load', start);
})();
